        <div class="footer-sec gap-3"  [ngClass]="{
            'buttons-center': !isMediumSize,
            'buttons-left': isMediumSize,
            'display-footer': !getHidden(),
            'no-display-footer': getHidden()}">
        
        <div   class="button-style gap-2">
            <ng-container #target></ng-container>
        </div>

        </div>


 
